"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watermelonSpriteRevision = exports.watermelonPhysics = void 0;
exports.getWatermelonToughness = getWatermelonToughness;
exports.drawWatermelon = drawWatermelon;
exports.updateWatermelon = updateWatermelon;
exports.constrainWatermelon = constrainWatermelon;
exports.smashWatermelon = smashWatermelon;
exports.updateWatermelonChunks = updateWatermelonChunks;
exports.drawWatermelonChunks = drawWatermelonChunks;
const physics_1 = require("../physics");
exports.watermelonPhysics = {
    releaseImpulse: 0, collisionRadiusRatio: 0.9, collisionRestitution: 0.08,
    popImpulse: 1800, popRadiusMultiplier: 2.5
};
function stateFor(melon) {
    return melon.watermelon ??= { toughness: Math.random(), rollBias: Math.random() < 0.5 ? -1 : 1,
        impacts: 0, grounded: false, highestBottom: melon.y + melon.radius * 0.85, chunks: [] };
}
function getWatermelonToughness(melon, physics) {
    return physics.watermelonToughnessMin + stateFor(melon).toughness
        * Math.max(0, physics.watermelonToughnessMax - physics.watermelonToughnessMin);
}
const watermelonSpriteRevision = () => 1;
exports.watermelonSpriteRevision = watermelonSpriteRevision;
function drawWatermelon(ctx, melon) {
    const r = melon.radius;
    ctx.save();
    ctx.translate(melon.x, melon.y);
    ctx.rotate(melon.angle);
    ctx.beginPath();
    ctx.ellipse(0, 0, r, r * 0.85, 0, 0, Math.PI * 2);
    ctx.fillStyle = '#55964a';
    ctx.fill();
    ctx.save();
    ctx.clip();
    ctx.strokeStyle = '#bbd568';
    ctx.lineWidth = r * 0.11;
    for (let i = -2; i <= 2; i++) {
        const y = i * r * 0.29;
        ctx.beginPath();
        ctx.moveTo(-r, y * 0.55);
        ctx.bezierCurveTo(-r * 0.4, y + r * 0.06, r * 0.4, y - r * 0.06, r, y * 0.55);
        ctx.stroke();
    }
    ctx.beginPath();
    ctx.ellipse(-r * 0.37, -r * 0.36, r * 0.21, r * 0.08, -0.45, 0, Math.PI * 2);
    ctx.fillStyle = '#dce9a0';
    ctx.fill();
    ctx.restore();
    ctx.strokeStyle = 'rgba(40,28,38,0.8)';
    ctx.lineWidth = Math.max(1.3, r * 0.03);
    ctx.beginPath();
    ctx.ellipse(0, 0, r, r * 0.85, 0, 0, Math.PI * 2);
    ctx.stroke();
    ctx.restore();
}
function updateWatermelon(melon, dt, width, ground, physics, objects) {
    const state = stateFor(melon);
    if (melon.pointerId !== null) {
        const follow = 1 - Math.exp(-physics.anchorStrength * dt);
        melon.x += (melon.anchorX - melon.x) * follow;
        melon.y += (melon.anchorY - melon.y) * follow;
        melon.vx = melon.vy = 0;
        state.grounded = false;
        state.highestBottom = melon.y + melon.radius * 0.85;
        return;
    }
    state.highestBottom = Math.min(state.highestBottom, melon.y + melon.radius * 0.85);
    if (!state.grounded)
        melon.vy += physics.watermelonGravity * dt;
    else {
        melon.vx *= Math.exp(-physics.watermelonRollingDrag * dt);
        if (Math.abs(melon.vx) < 1)
            melon.vx = 0;
    }
    melon.x += melon.vx * dt;
    melon.y += melon.vy * dt;
    melon.angle += (melon.vx / Math.max(1, melon.radius)) * dt;
    constrainWatermelon(melon, width, ground, physics, objects);
}
function constrainWatermelon(melon, width, ground, physics, objects) {
    if (melon.popped)
        return;
    const state = stateFor(melon);
    const bottom = melon.radius * Math.sqrt(0.85 ** 2 * Math.cos(melon.angle) ** 2 + Math.sin(melon.angle) ** 2);
    const floor = Math.max(bottom, ground - bottom);
    const margin = Math.min(melon.radius, width / 2);
    if (melon.x < margin || melon.x > width - margin)
        melon.vx *= -0.3;
    melon.x = Math.max(margin, Math.min(width - margin, melon.x));
    if (melon.y >= floor) {
        melon.y = floor;
        // The collision pass can constrain twice in one frame; preserve a bounce
        // that already sent the melon upward on the first pass.
        if (melon.pointerId === null && melon.vy < 0)
            return;
        const incoming = Math.max(0, melon.vy);
        const toughness = getWatermelonToughness(melon, physics);
        if (melon.pointerId === null && !state.grounded
            && ground - state.highestBottom >= ground * physics.watermelonBurstHeightRatio * toughness) {
            (0, physics_1.popWithForce)(objects, melon);
            return;
        }
        if (melon.pointerId === null && !state.grounded && incoming > 45) {
            state.impacts++;
            // A slightly off-center landing sends a surviving melon rolling.
            if (state.impacts === 1)
                melon.vx += state.rollBias * Math.min(85, incoming * 0.18);
            melon.vy = -incoming * physics.watermelonBounce;
            state.grounded = false;
            state.highestBottom = ground;
        }
        else {
            melon.vy = 0;
            state.grounded = melon.pointerId === null;
            state.highestBottom = ground;
        }
    }
    else if (state.grounded && melon.y < floor - 1) {
        state.grounded = false;
        state.highestBottom = melon.y + bottom;
    }
    else if (state.grounded) {
        // Follow the changing support radius of an oval as it rolls.
        melon.y = floor;
    }
}
function smashWatermelon(melon) {
    const state = stateFor(melon);
    state.grounded = false;
    state.chunks = Array.from({ length: 9 }, (_, i) => {
        const angle = Math.PI + Math.random() * Math.PI;
        const speed = 120 + Math.random() * 260;
        return { x: melon.x, y: melon.y, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed - 90,
            angle: i * 0.8, spin: (Math.random() - 0.5) * 10, size: melon.radius * (0.25 + Math.random() * 0.2) };
    });
}
function updateWatermelonChunks(melon, dt, width, ground, _config) {
    for (const chunk of melon.watermelon?.chunks ?? []) {
        chunk.vy += 700 * dt;
        chunk.x += chunk.vx * dt;
        chunk.y += chunk.vy * dt;
        chunk.angle += chunk.spin * dt;
        if (chunk.y > ground - chunk.size * 0.4) {
            chunk.y = ground - chunk.size * 0.4;
            if (chunk.vy > 0)
                chunk.vy *= -0.25;
            chunk.vx *= Math.exp(-7 * dt);
            chunk.spin *= Math.exp(-7 * dt);
        }
    }
}
let chunkSprite = null;
function drawWatermelonChunks(ctx, melon) {
    if (!chunkSprite) {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 64;
        const art = canvas.getContext('2d');
        if (!art)
            return;
        art.beginPath();
        art.moveTo(32, 7);
        art.lineTo(59, 46);
        art.quadraticCurveTo(33, 65, 5, 46);
        art.closePath();
        art.fillStyle = '#287d36';
        art.fill();
        art.beginPath();
        art.moveTo(32, 9);
        art.lineTo(54, 44);
        art.quadraticCurveTo(32, 57, 10, 44);
        art.closePath();
        art.fillStyle = '#d7e5a0';
        art.fill();
        art.beginPath();
        art.moveTo(32, 10);
        art.lineTo(50, 42);
        art.quadraticCurveTo(32, 52, 14, 42);
        art.closePath();
        art.fillStyle = '#ed4860';
        art.fill();
        art.fillStyle = '#45272c';
        for (const [x, y] of [[30, 25], [24, 36], [39, 37]]) {
            art.beginPath();
            art.ellipse(x, y, 1.5, 3, -0.2, 0, Math.PI * 2);
            art.fill();
        }
        chunkSprite = canvas;
    }
    for (const chunk of melon.watermelon?.chunks ?? []) {
        ctx.save();
        ctx.globalAlpha = Math.max(0, Math.min(1, (1.8 - melon.popTime) / 0.5));
        ctx.translate(chunk.x, chunk.y);
        ctx.rotate(chunk.angle);
        ctx.drawImage(chunkSprite, -chunk.size / 2, -chunk.size / 2, chunk.size, chunk.size);
        ctx.restore();
    }
}
//# sourceMappingURL=watermelon.js.map